import { ReactNode } from 'react';

import { CssBaseline, ThemeProvider } from '@mui/material';

import getTheme from '@/config/theme';
import { getUserTypeFromHostname } from '@/shared/lib/UserTypeContext/UserTypeContext';

import AppCrashPage, { goToAppRoot } from './AppCrashPage';
import ErrorBoundary from './ErrorBoundary';

interface Props {
  children: ReactNode;
}

// Last line of defence, mounted above every provider (Keycloak, i18n, theme,
// React Query): anything they throw lands here instead of unmounting the app to
// a white page. The fallback supplies its own theme because the app's is gone.
function RootErrorBoundary({ children }: Props) {
  return (
    <ErrorBoundary
      renderFallback={({ error }) => (
        <ThemeProvider theme={getTheme(getUserTypeFromHostname(window.location.hostname))}>
          <CssBaseline />
          <AppCrashPage error={error} fullScreen onGoHome={goToAppRoot} />
        </ThemeProvider>
      )}
    >
      {children}
    </ErrorBoundary>
  );
}

export default RootErrorBoundary;
